import RestClient from '../RestClient/RestClient';
import RewardsApiConstants from './RewardsApiConstants';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
/**
 * This class is responsible of providing all the rewards API.
 */

export const getRewards = (obj) => {
    if (obj && obj.accountId) {
        let config = {};
        config = RestConfig.v5AccountConfig();
        config = getHostConfig(config);
        config.url = `${RewardsApiConstants.CAM_BASE}/${obj.accountId}/${RewardsApiConstants.REWARDS_URL}`;
        const { payload: { enableThirdPartyCoupons, disableExpand } = {} } = obj;
        config.params = {
            ...(!disableExpand && { expand: 'points,certificates,recentactivity' }),
            ...(enableThirdPartyCoupons && { certType: 'ALL' }),
        };
        config.isAuthRequired = true;
        config.accessToken = obj.accessToken;

        return RestClient.get(config).then((json) => json); // catch not required already handled in ResClient/FetchHelper.js
    }
    return null;
};

export const getRewardsSyf = (obj = {}) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config.url = `${RewardsApiConstants.REWARD_BASE}/${obj.accountId}/${RewardsApiConstants.SYNCHRONY}`;

    if (obj.accessToken) {
        config.accessToken = obj.accessToken;
    }

    config = getHostConfig(config);
    return RestClient.get(config).then((json) => json);
};

export const postRewardsSyf = (postData) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url = `${RewardsApiConstants.REWARD_BASE}/${postData.accountId}/${RewardsApiConstants.CREDIT_APPLICATION}`;

    const { sdp } = postData.payload;
    config.params = {
        accountId: postData.accountId,
        sdp,
    };
    config.accessToken = postData.accessToken;
    return RestClient.post(config).then((json) => json);
};
export const postRewardsWallet = (postData) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url = `${RewardsApiConstants.REWARD_BASE}/${postData.accountId}/${RewardsApiConstants.WALLET}`;
    config.params = {};
    config.accessToken = postData.accessToken;
    const { guestAccountId } = postData.payload;
    if (guestAccountId) {
        config.guestAccountId = guestAccountId;
    }
    return RestClient.post(config).then((json) => json);
};

export const getHeader = (hostPath) => {
    const config = {
        url: 'j/global/header',
        params: {
            external: 'true',
        },
        credentials: 'include',
        host: hostPath,
        version: '/',
        // isApiTokenRequired: true,
    };
    return RestClient.get(config).then((json) => json);
};

export const getFooter = (hostPath) => {
    const config = {
        url: 'j/global/footer',
        params: {
            external: 'true',
        },
        credentials: 'include',
        host: hostPath,
        version: '/',
        // isApiTokenRequired: true,
    };
    return RestClient.get(config).then((json) => json);
};

export const getRewardsHistory = (obj) => {
    if (obj && obj.accountId) {
        let config = {};
        config = RestConfig.v5AccountConfig();
        config = getHostConfig(config);
        config.url =
            `${RewardsApiConstants.CAM_BASE}/${obj.accountId}` +
            `/${RewardsApiConstants.REWARDS_URL}/${RewardsApiConstants.REWARDS_HISTORY}`;
        config.params = obj.payload;
        config.isAuthRequired = true;
        config.accessToken = obj.accessToken;

        return RestClient.get(config).then((json) => json); // catch not required already handled in ResClient/FetchHelper.js
    }
    return null;
};

export const getActivityHistory = (obj) => {
    if (obj && obj.accountId) {
        let config = {};
        config = RestConfig.v5AccountConfig();
        config = getHostConfig(config);
        config.url =
            `${RewardsApiConstants.CAM_BASE}/${obj.accountId}` +
            `/${RewardsApiConstants.REWARDS_URL}/${RewardsApiConstants.ACTIVITY_HISTORY}`;
        config.params = obj.payload;
        config.isAuthRequired = true;
        config.accessToken = obj.accessToken;

        return RestClient.get(config).then((json) => json); // catch not required already handled in ResClient/FetchHelper.js
    }
    return null;
};

export const getTransactionDetails = (obj) => {
    if (obj && obj.accountId && obj.payload.id) {
        let config = {};
        config = RestConfig.v5AccountConfig();
        config = getHostConfig(config);
        config.url =
            `${RewardsApiConstants.CAM_BASE}/${obj.accountId}` +
            `/${RewardsApiConstants.REWARDS_URL}/${RewardsApiConstants.TRANSACTION_DETAILS}/${obj.payload.id}`;
        config.isAuthRequired = true;
        config.accessToken = obj.accessToken;
        return RestClient.get(config).then((json) => json); // catch not required already handled in ResClient/FetchHelper.js
    }
    return null;
};

export const getPoints = (params) => {
    if (params && params.accountId) {
        const config = {
            url: `${RewardsApiConstants.CAM_BASE}/${params.accountId}/${RewardsApiConstants.POINTS_CARD}`,
            credentials: 'include',
        };

        return RestClient.get(config).then((json) => json); // catch not required already handled in ResClient/FetchHelper.js
    }
    return null;
};

export const postMissingPoints = (postData) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url =
        `${RewardsApiConstants.CAM_BASE}/${postData.accountId}/${RewardsApiConstants.REWARD_BASE}` +
        `/${RewardsApiConstants.MISSING_POINTS}`;
    config.params = postData.payload;
    config.isAuthRequired = true;
    config.accessToken = postData.accessToken;
    return RestClient.post(config).then((json) => json);
};

export const putRewardsProfile = (postData) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url = `${RewardsApiConstants.CAM_BASE}/${postData.accountId}/${RewardsApiConstants.REWARDS_URL}`;
    config.params = postData.payload;
    config.isAuthRequired = true;
    config.accessToken = postData.accessToken;
    config.userAction = postData.userAction;
    config.isDPClusterRequired = true;
    return RestClient.put(config).then((json) => json);
};

export const updateRewardsSettings = (postData) => {
    let config = {};
    config = RestConfig.v5AccountConfig();
    config = getHostConfig(config);
    config.url = `${RewardsApiConstants.CAM_BASE}/${postData.accountId}/${RewardsApiConstants.REWARDS_URL}`;
    config.params = postData.payload;
    config.isAuthRequired = true;
    config.accessToken = postData.accessToken;
    config.isDPClusterRequired = true;
    return RestClient.patch(config).then((json) => json);
};

export const getMissingPointsHistory = (postData) => {
    if (postData && postData.accountId) {
        let config = {};
        config = RestConfig.v5AccountConfig();
        config = getHostConfig(config);
        config.url =
            `${RewardsApiConstants.CAM_BASE}/${postData.accountId}` +
            `/${RewardsApiConstants.REWARD_BASE}/${RewardsApiConstants.MISSING_POINTS}` +
            `/${RewardsApiConstants.TRANSACTIONS}`;
        config.accessToken = postData.accessToken;
        config.isAuthRequired = true;
        config.params = postData.payload;
        return RestClient.get(config).then((json) => json);
    }
    return null;
};
